import { i18n, DivButton, Icon, utils } from '@common';
import { useEffect } from 'react';
import './loginSingPass.less';
import { redirectTransferTo } from '../../utils/utils';
const LoginSingPass = props => {
    const loginSession = JSON.parse(sessionStorage['transferData'] || null);
    const emailLogicalName = loginSession?.detail?.EmailOTP?.logicalName;

    const handleButtonClick = () => {
        window.wogaaCustom?.startTransactionalService('cispoliteedu-4704');
        redirectTransferTo(emailLogicalName);
    };
    const handleSingpassClick = () => {
        const singpassLogicalName = loginSession?.detail?.SingPass?.logicalName;
        const params = utils.geturlparam(window?.location.search);
        redirectTransferTo(singpassLogicalName, '', '', params?.obj?.proxyState);
    };
    return (
        <>
            <div className='singPassHome'>
                <div className='singpass-icon' onClick={handleSingpassClick}>
                </div>
            </div>
            {emailLogicalName && <div className='emailOtpLinkBox'>
                <div className='emailOtpLinkMessage'>
                    {i18n.get('CIS_Home_Singpass_Tab_EmailOTP_PreLink_Entry')}
                    &nbsp;
                    <DivButton className='i' id="emial-otp-link" type="link" onClick={handleButtonClick}>
                        {i18n.get('CIS_Home_Singpass_Tab_EmailOTP_SufLink_Entry')}
                    </DivButton>
                </div>
            </div>}
            <div className='InstructionBox'>
                <div className='Instruction'>
                    <div className='font-bold' style={{ fontSize: '18px' }} >{i18n.get('CIS_Home_Tab_InstructionTitle_Entry')}</div>
                    <div style={{ fontSize: '16px', color: "#A0A0A0" }}>{i18n.get('CIS_Home_Tab_Singpass_Instruction_Message')}</div>
                </div>
            </div>
        </>
    );
};
export default LoginSingPass;